/* React core */
import { Component } from "react"
/* Redux binding */
import { connect } from "react-redux"

/* Router and shared utilities */
import { withRouter, utils } from "../helpers"
/* Icon component */
import Icon from "./Icon"
/* Favourite API */
import { add, remove } from "../api/Favourite"

/* Translation */
import { translate } from "../translates"

/* Component Card */
class Card extends Component {

    /* Draw Is Fav */
    _isFav = () => {
        const favourites = this.props.favourites
        return Array.isArray(favourites) && favourites.some(item => item.id === this.props.s.id)
    }

    /* Draw Favourite */
    _favourite = (event) => {
        event.stopPropagation()
        if (!this.props.token) {
            this.props.toggleAuth(true)
            return
        }
        const organization = this.props.s
        if (this._isFav()) {
            remove(this.props.token, organization.id)
            this.props.removeFavourite(organization)
        }
        else {
            add(this.props.token, organization.id)
            this.props.addFavourite(organization)
        }
    }

    render = () => {
        const s = this.props.s
        const isFav = this._isFav()
        const tags = Array.isArray(s.tags) ? s.tags : []

        const addr = s.addr || s.address || ""

        return (
            <article className="card" onClick={() => this.props.navigate(`/organization/${s.url || s.id}`)}>
                <div className="card__media">
                    <img src={utils.media(s.image) || utils.FALLBACK_IMG} alt={s.name} onError={utils.onImgError} />
                    <button
                        className={`card__fav ${isFav ? "is-active" : ""}`}
                        onClick={this._favourite}
                        aria-label={translate("В избранное")}
                    >
                        <Icon name="heart" size={18} fill={isFav ? "currentColor" : "none"} />
                    </button>
                </div>
                <div className="card__body">
                    <div className="card__title">{s.name}</div>
                    <div className="card__rating">
                        <Icon name="star" size={14} fill="currentColor" stroke="none" />
                        {s.rating ? Number(s.rating).toFixed(1) : "—"}
                        <span className="card__rating-count">({s.reviewsCount || 0} {utils.plural(s.reviewsCount || 0, ["отзыв", "отзыва", "отзывов"])})</span>
                    </div>
                    {addr ? (
                        <div className="card__addr">
                            <Icon name="pin" size={14} />
                            <span style={{ flex: 1 }}>{addr}</span>
                            {s.distance != null && <span className="card__dist">{utils.distance(s.distance)}</span>}
                        </div>
                    ) : null}
                    {tags.length > 0 && (
                        <div className="card__services">
                            {tags.slice(0, 3).map((tag, index) => <span key={`${index}`} className="card__service-chip">{tag}</span>)}
                        </div>
                    )}
                </div>
            </article>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        token: state.token,
        favourites: state.favourites,
        lang: state.lang
    }
}

/* Map Dispatch To Props */
const mapDispatchToProps = dispatch => {
    return {
        toggleAuth: data => dispatch({ type: "TOGGLE_AUTH", payload: data }),
        addFavourite: data => dispatch({ type: "ADD_FAVOURITE", payload: data }),
        removeFavourite: data => dispatch({ type: "REMOVE_FAVOURITE", payload: data })
    }
}

/* Export */
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Card))
